
export default function usePrices (hubbleClient) {
  if (!hubbleClient) {
    throw new Error('You must provide the hubbleClient to use this composable');
  }
  const getPricePerSku = async (productSku, categoryId) => {
    const res = await hubbleClient.prices.getPricePerSku(productSku, categoryId);
    return res;
  }

  return {
    getPricePerSku
  }
}
